import React__default from 'react';
import PropTypes from 'prop-types';
import Title from './Title.js';
import { n as nodeOrStringProp } from './PropTypes-9aad034b.js';

var Card = React__default.forwardRef(function (props, ref) {
  var children = props.children,
    content = props.content,
    transparent = props.transparent,
    title = props.title,
    className = props.className,
    titleAction = props.titleAction,
    largePadding = props.largePadding,
    noPadding = props.noPadding;
  var cardClassName = "".concat(className, "\n        bf-card\n        ").concat(transparent ? ' bf-card-transparent' : '', "\n        ").concat(largePadding ? 'bf-card-with-large-padding' : '', "\n        ").concat(noPadding ? 'bf-card-without-padding' : '', "\n    ");
  var titleSize = props.titleSize;
  var allowedSizes = ['small', 'normal', 'medium', 'large', 'xlarge', 'huge', 'extra'];
  titleSize = allowedSizes.some(function (validSize) {
    return validSize === titleSize;
  }) ? "".concat(titleSize) : '';
  return /*#__PURE__*/React__default.createElement("div", {
    className: cardClassName,
    ref: ref
  }, title ? /*#__PURE__*/React__default.createElement("div", {
    className: "bf-card-header"
  }, /*#__PURE__*/React__default.createElement(Title, {
    size: titleSize,
    content: title
  }), titleAction ? /*#__PURE__*/React__default.createElement("div", {
    className: "bf-card-title-action"
  }, titleAction) : null) : null, content || children);
});
Card.defaultProps = {
  children: '',
  content: '',
  transparent: false,
  title: '',
  titleSize: 'large',
  className: '',
  titleAction: '',
  largePadding: false,
  noPadding: false
};
Card.propTypes = {
  /**
  Card content
   */
  children: nodeOrStringProp,
  /**
  Card content
   */
  content: nodeOrStringProp,
  /**
  Card without background
   */
  transparent: PropTypes.bool,
  /**
  Card title
   */
  title: nodeOrStringProp,
  /**
  Card title size
   */
  titleSize: PropTypes.string,
  /**
  Custom className
   */
  className: PropTypes.string,
  /**
  Card title side element
   */
  titleAction: nodeOrStringProp,
  /**
  Card larger padding
   */
  largePadding: PropTypes.bool,
  /**
  Card without padding
   */
  noPadding: PropTypes.bool
};
Card.displayName = 'Card';

export { Card as C };
